export default __webpack_public_path__ + "bd7aab17f40932d6262eb9a91c0afa76.png";